import { AxiosResponse } from "axios";
import { useEffect } from "react";
import { useContext, useState } from "react";
import { AdminFrame } from "views/common/AdminFrame";
import { getApiDataWithToken } from "views/utils/CallApi";
import * as mb from "views/common/MessageBox";
import { CtxAuth } from "views/utils/Contexts";
import { pageNoCurrent, pageMaxCurrent, allPage, pageSend, selectPage} from "views/utils/PagingFunc"

interface IFOrderHistory {
    orderNo: string,
    orderName: string,
    createDate: string,
    orderStatus: number,
    orderTotalPrice: number,
    billingPrice: number,
    scheduledDate: string,
    scheduleStartTime: string,
    scheduleEndTime: string,
    billingDate: string,
    firstTimeFlg: number,
    parkingSpaceFlg: number,
    pageNo: number
}

interface IFSumPrice {
    sumOrderTotalPrice: number,
    sumBillingPrice: number
}

interface IFQuantity {
    pages: number
}


export function OrderList(): JSX.Element{

    const cua = useContext(CtxAuth);
    const [msgArgs, setMsgArgs] = useState({type:"", text:""});
    const [orderHistory, setOrderHistory] = useState<IFOrderHistory[]>();
    const [sumPrice, setSumPrice] = useState<IFSumPrice>({
        sumOrderTotalPrice:0,
        sumBillingPrice:0
    });
    const [pageQuantity, setPageQuantity] = useState<IFQuantity[]>();
    const [maxPage, setMaxPage] = useState<number>(0);
    sessionStorage.setItem('order_url', window.location.href)

    //年・月・日を取得
    function dateReplace(fullDay: string){
        const day = fullDay.split(" ");
        const result = day[0];

        return result
    }

    //月のみ取得
    function getMonth(fullDay: string){
        const day = fullDay.split(" ");
        const result = day[0].split("/");
        const year = result[0]
        const month = result[1].padStart(2,'0')

        return Number(year + month)
    }

    //時・分を取得
    function timeReplace(fullDay: string){
        const day = fullDay.split(" ");
        const fullTime = day[1].split(":");
        const result = (fullTime[0] + ":" + fullTime[1]);

        return result
    }

    function kakuteiTimeReplace(fullDay: string){
        const fullTime = fullDay.split(":");
        const result = (fullTime[0] + ":" + fullTime[1]);

        return result
    }

    function billingJudge(val: number, status: number){
        if (status !== 50) {
            val = 0
        }
        return val;
    }

    useEffect(function(){

        //初期値取得
        const odHistory:IFOrderHistory[] = [];
        let sPrice:IFSumPrice = {sumOrderTotalPrice:0, sumBillingPrice:0};
        const qHistory:IFQuantity[] = [];
        var sumOrderTotalPrice = 0;
        var sumBillingPrice = 0;

        getApiDataWithToken('/management/orders',
            {},
            cua.getToken(),
            function(res:AxiosResponse<any>){
                switch (res.status) {
                    case 200:
                        for (let index = 0; index < res.data.order_list.length; index++) {
                            odHistory.push({
                                orderNo:res.data.order_list[index].order_no,
                                orderName:res.data.order_list[index].order_name,
                                createDate:res.data.order_list[index].create_date,
                                orderStatus:res.data.order_list[index].order_status,
                                orderTotalPrice:res.data.order_list[index].order_total_price,
                                billingPrice:billingJudge(res.data.order_list[index].billing_price, res.data.order_list[index].order_status),
                                scheduledDate:res.data.order_list[index].scheduled_date,
                                scheduleStartTime:res.data.order_list[index].schedule_start_time,
                                scheduleEndTime:res.data.order_list[index].schedule_end_time,
                                billingDate:res.data.order_list[index].billing_date,
                                firstTimeFlg:res.data.order_list[index].first_time_flg,
                                parkingSpaceFlg:res.data.order_list[index].parking_space_flg,
                                pageNo:res.data.order_list[index].page_no
                            });
                            if (getMonth(new Date().toLocaleString()) === getMonth(res.data.order_list[index].create_date)) {
                                if (res.data.order_list[index].order_status !== 99) {
                                    sumOrderTotalPrice += res.data.order_list[index].order_total_price
                                }
                            }
                            if (getMonth(new Date().toLocaleString()) === getMonth(res.data.order_list[index].billing_date)) {
                                if (res.data.order_list[index].order_status === 50) {
                                    sumBillingPrice += res.data.order_list[index].billing_price
                                }
                            }
                        }
                        sPrice = {
                            sumOrderTotalPrice:sumOrderTotalPrice,
                            sumBillingPrice:sumBillingPrice
                        }
                        const array = allPage(res.data.page_max_no)
                        for (let index = 0; index < res.data.page_max_no; index++) {
                            qHistory.push({
                                pages:array[index]
                            })
                        }
                        var url = window.location.href
                        var pageOrder = []
                        if (url.match(/pageNo=/)) {
                            var pageNoStart = url.indexOf('pageNo=')
                            var pageNoEnd = url.indexOf('maxPage=')
                            var result = Number(url.substring((pageNoStart + 7), (pageNoEnd - 1)))
                            pageOrder = odHistory.filter(item => item.pageNo === result)
                        } else {
                            pageOrder = odHistory.filter(item => item.pageNo === 1)
                        }
                        setOrderHistory(pageOrder);
                        setSumPrice(sPrice);
                        setPageQuantity(qHistory);
                        setMaxPage(res.data.page_max_no);
                        
                        break;
                    default:
                        setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"画面のロードに失敗しました。"});
                }
                
                
            }
        );

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <AdminFrame>
            <div className="contents">
            <mb.MessageBox args={msgArgs}/>
                <h2 className="settings-title-h2">注文管理</h2>
                <div className="control-horizon control-between control-vcenter">
                <button className="btn-secondary" onClick={function(){window.location.href='edit'}} style={{visibility: "hidden"}}>新規登録</button>
                <div className="control-horizon control-wrap">
                    <div className="order-list-earnings">今月の見積合計金額：<span className="text-size-l">{sumPrice.sumOrderTotalPrice.toLocaleString()}</span>円</div>
                    <div className="order-list-earnings">今月の請求済み合計金額：<span className="text-size-l">{sumPrice.sumBillingPrice.toLocaleString()}</span>円</div>
                </div>
                </div>
                <div className="tbl-wrap">
                    <table className="tbl margin-tb-20">
                        <thead>
                            <tr>
                            <th style={{width: "150px"}}>注文日時</th>
                            <th>注文者</th>
                            <th style={{width: "150px"}}>ステータス</th>
                            <th style={{width: "150px"}}>確定予約日時</th>
                            <th style={{width: "150px"}} className="text-right">見積合計金額</th>
                            <th style={{width: "150px"}} className="text-right">請求済み金額</th>
                            </tr>
                        </thead>
                        {orderHistory?.map(function(val, idx){
                            return(
                                <tbody key={idx}>
                                    <tr>
                                        <td>{dateReplace(val.createDate)}<br/>{timeReplace(val.createDate)}</td>
                                        <td>
                                            <div className="control-horizon control-between">
                                            <div>
                                                <div><a href={"edit?orderNo=" + val.orderNo}>{val.orderNo}</a></div>
                                                <div className="text-size-l"><a href={"edit?orderNo=" + val.orderNo}>{val.orderName}</a></div>
                                            </div>
                                            <div>
                                                {val.firstTimeFlg === 0 && <span className="icon-repeat material-icons-round" title="新規顧客">face_retouching_natural</span>}
                                            </div>
                                            </div>
                                        </td>

                                        <td>
                                            {(() => {
                                                if (val.orderStatus === 10) {
                                                    return(
                                                        <span className="tag tag-red tag-block">受注中</span>
                                                    )
                                                } else if (val.orderStatus === 20) {
                                                    return(
                                                        <span className="tag tag-orange tag-block">確定</span>
                                                    )
                                                } else if (val.orderStatus === 50) {
                                                    return(
                                                        <span className="tag tag-purple tag-block">対応済み</span>
                                                    )
                                                } else if (val.orderStatus === 99) {
                                                    return(
                                                        <span className="tag tag-gray tag-block">キャンセル</span>
                                                    )
                                                }
                                            })()}
                                        </td>
                                        <td>
                                            {(() => {
                                                if (val.scheduledDate === null) {
                                                    return(
                                                        <span key={idx} className="text-color-red">未確定</span>
                                                    )
                                                } else {
                                                    return(
                                                        <span key={idx}>{dateReplace(val.scheduledDate)}<br/>{kakuteiTimeReplace(val.scheduleStartTime)} - {kakuteiTimeReplace(val.scheduleEndTime)}</span>
                                                    )
                                                }
                                            })()}
                                        </td>
                                        <td className="text-right">{val.orderTotalPrice.toLocaleString()}</td>
                                        <td className="text-right">{val.billingPrice.toLocaleString()}</td>
                                        </tr>
                                </tbody>
                            )
                        })}
                    </table>
                </div>
                <div>
                    <ul className="pagenation">
                        { pageNoCurrent() > 1 ? <li><a href={"?pageNo=" + pageSend(0) + "&maxPage=" + maxPage}>＜</a></li>:<li><a href="/#" onClick={e => e.preventDefault()}>＜</a></li>}
                            {pageQuantity?.map(function(val, idx){
                                return(
                                    <li key={idx}>
                                        <ul>
                                        {selectPage(val.pages) 
                                        ? <li className="is-current">{val.pages}</li>
                                        : <a href={"?pageNo=" + val.pages + "&maxPage=" + maxPage}>{val.pages}</a>
                                        }
                                        </ul>
                                    </li>
                                )
                            })}
                        { pageMaxCurrent(maxPage) ? <li><a href={"?pageNo=" + pageSend(1) + "&maxPage=" + maxPage}>＞</a></li>:<li><a href="/#" onClick={e => e.preventDefault()}>＞</a></li>}
                    </ul>
                </div>
            </div>
        </AdminFrame>
    )
}